import { getAllDepartments } from '@/modules/Employee/services'
import { useQuery } from '@tanstack/react-query'
import { FieldValues, Path, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { FilterSelect } from '@/components/ui/filters'

interface DepartmentSelectProps<T extends FieldValues> {
    control: UseFormReturn<T, any, any>['control']
    name: Path<T>
    label?: string
    showClearButton?: boolean
    onChangeAfterHookForm?: (value?: any) => void
}

const DepartmentSelect = <T extends FieldValues>({
    control,
    name,
    label,
    showClearButton,
    onChangeAfterHookForm,
}: DepartmentSelectProps<T>) => {
    const { data, isFetching } = useQuery({
        queryKey: [QUERY_KEYS.DEPARTMENTS],
        queryFn: getAllDepartments,
    })

    const { t } = useTranslation()

    const options =
        data?.results?.map((item) => ({
            label: item.department_name,
            value: item.department_id,
        })) || []

    return (
        <FilterSelect
            control={control}
            name={name}
            label={t(label || 'department')}
            placeholder={t('department_placeholder')}
            options={options}
            disabled={isFetching}
            showClearButton={showClearButton}
            onChangeAfterHookForm={onChangeAfterHookForm}
        />
    )
}

export default DepartmentSelect
